/* eslint-disable no-unused-vars */
import { memo } from 'react';
import * as S from './TooltipMessage.styled';
import { format, isValid } from 'date-fns';
import { isDateWasReached } from 'utils';

const PauseStatusTextMessage = ({ schedulerStartDate, schedulerEndDate }) => {
  if (!schedulerStartDate && !schedulerEndDate) return null;
  if (isDateWasReached(schedulerStartDate) && !schedulerEndDate) {
    return null;
  }
  if (schedulerStartDate && !isDateWasReached(schedulerStartDate)) {
    return (
      <p style={{ marginTop: '8px' }}>
        Scheduled to Start at: <strong>{formatDate2(schedulerStartDate)}</strong>
      </p>
    );
  }
  if (schedulerEndDate && !isDateWasReached(schedulerEndDate)) {
    return (
      <p style={{ marginTop: '8px' }}>
        Scheduled to End at: <strong>{formatDate2(schedulerEndDate)}</strong>
      </p>
    );
  }
  if (schedulerEndDate && isDateWasReached(schedulerEndDate)) {
    return (
      <p style={{ marginTop: '8px' }}>
        Campaign reached its end date: <strong>{formatDate2(schedulerEndDate)}</strong>
      </p>
    );
  }
};

const PlayStatusTextMessage = ({
  schedulerStartDate,
  schedulerEndDate,
  statusDescr,
  // isLimited,
}) => {
  // if (isLimited) {
  //   return <p>{statusDescr}</p>;
  // }
  if (!schedulerStartDate && !schedulerEndDate) return null;
  if (isDateWasReached(schedulerStartDate) && !schedulerEndDate) {
    return null;
  }
  if (schedulerStartDate && !isDateWasReached(schedulerStartDate)) {
    return (
      <p style={{ marginTop: '8px' }}>
        Scheduled to Start at: <strong>{formatDate2(schedulerStartDate)}</strong>
      </p>
    );
  }
  if (schedulerEndDate && !isDateWasReached(schedulerEndDate)) {
    return (
      <p style={{ marginTop: '8px' }}>
        Scheduled to End at: <strong>{formatDate2(schedulerEndDate)}</strong>
      </p>
    );
  }
  return null;
};

export const TooltipMessage = memo(
  ({
    schedulerStartDate,
    schedulerEndDate,
    campaignStatus,
    status,
    isDraft,
    icon,
    _hasBanners,
    banner_list_no_tracking,
    statusDescr,
    status_name,
    call_to_action,
  }) => {
    const isLimited = statusDescr?.includes('limit') && status_name === 'open';
    return (
      <S.TooltipMessage>
        <S.MessageTitle>
          {icon}
          {getTitle(campaignStatus, status, isDraft, isLimited, statusDescr, call_to_action)}
        </S.MessageTitle>
        {campaignStatus === 0 && (
          <PlayStatusTextMessage
            schedulerStartDate={schedulerStartDate}
            schedulerEndDate={schedulerEndDate}
            isLimited={isLimited}
            statusDescr={statusDescr}
          />
        )}
        {campaignStatus == 3 && !isDraft && (
          <PauseStatusTextMessage
            schedulerStartDate={schedulerStartDate}
            schedulerEndDate={schedulerEndDate}
          />
        )}
        {campaignStatus == 3 && isDraft && (
          <DraftMessage
            _hasBanners={_hasBanners}
            banner_list_no_tracking={banner_list_no_tracking}
          />
        )}
        {(campaignStatus == 4 || campaignStatus == 8) && (
          <p style={{ marginTop: '8px' }}>No Funds</p>
        )}
      </S.TooltipMessage>
    );
  },
);

const DraftMessage = ({ _hasBanners, banner_list_no_tracking }) => {
  if (_hasBanners === 0) {
    return <p style={{ marginTop: '8px' }}>Please add Creatives</p>;
  }
  if (_hasBanners === 0 && banner_list_no_tracking !== '') {
    return <p style={{ marginTop: '8px' }}>Please add Creatives</p>;
  }
  if (_hasBanners === 1 && banner_list_no_tracking !== '') {
    return <p style={{ marginTop: '8px' }}>Please add Tracking</p>;
  }
};

function getTitle(campaignStatus, status, isDraft, isLimited, statusDescr, call_to_action) {
  if (status == 4)
    return (
      <p style={{ color: '#EF4444', maxWidth: '150px', marginLeft: '4px', lineHeight: '1.1' }}>
        Out of budget: <br /> Daily limit reached. Campaign stopped serving.
      </p>
    );
  if (call_to_action == 4)
    return (
      <p style={{ color: '#EF4444', maxWidth: '140px', marginLeft: '4px', lineHeight: '1.1' }}>
        Limited by budget: <br />
        Increasing budget may improve performance.
      </p>
    );
  if (campaignStatus == 0 && !isLimited) return <p style={{ color: '#17ABA3' }}>Active</p>;
  if (campaignStatus == 0 && isLimited)
    return <p style={{ color: '#EF4444' }}>{formatStatusDescr(statusDescr)}</p>;
  if (campaignStatus == 3 && !isDraft) return <p style={{ color: '#FCAF17' }}>Paused</p>;
  if (campaignStatus == 3 && isDraft) return <p style={{ color: '#334155' }}>Draft</p>;
  if (campaignStatus == 4 || campaignStatus == 8)
    return <p style={{ color: '#EF4444' }}>Suspended</p>;
  if (campaignStatus == 9) return <p style={{ color: '#94A3B8' }}>Archived</p>;
}

function formatStatusDescr(text) {
  if (!text) return '';
  const spaced = String(text).replace(/([A-Z])/g, (_, char, index, input) => {
    if (index === 0 || input[index - 1] === ' ') return char;
    return ` ${char}`;
  });
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

function formatDate2(inputDate) {
  try {
    const uTCschedulerStartDate = new Date((new Date(inputDate) + 'UTC').toLocaleString());
    if (!uTCschedulerStartDate || !isValid(uTCschedulerStartDate)) {
      throw new Error('Invalid date');
    }
    return format(uTCschedulerStartDate, "MMMM dd, yyyy 'at' HH:mm");
  } catch (error) {
    console.error('Date formatting error:', error.message);
    return 'Invalid date';
  }
}

TooltipMessage.displayName = 'TooltipMessage';
